import ApiClient from '@afosto/api/ApiClient';

class Operations {
  constructor(client) {
    this.apiClient = client || ApiClient;
  }

  /**
   * Clone object
   *
   * @param {Number} id
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Clone an object to external storage
   * @returns {Promise}
   */
  cloneObject(id, body, options = {}) {
    return this.apiClient.request({
      url: `/cnt/filesystems/integrations/${id}`,
      method: 'post',
      data: body,
      ...options,
    });
  }

  /**
   * Delete object
   *
   * @param {Number} id
   * @param {string} path
   * @param {Object} options - The additional request options
   * @description Delete an object at external storage
   * @returns {Promise}
   */
  deleteObject(id, path, options = {}) {
    const params = {
      path,
    };

    return this.apiClient.request({
      url: `/cnt/filesystems/integrations/${id}`,
      method: 'delete',
      params,
      ...options,
    });
  }

  /**
   * List objects
   *
   * @param {Number} id
   * @param {string} path
   * @param {Object} options - The additional request options
   * @description List objects at external storage
   * @returns {Promise}
   */
  listObjects(id, path, options = {}) {
    const params = {
      path,
    };

    return this.apiClient.request({
      url: `/cnt/filesystems/integrations/${id}/list`,
      method: 'get',
      params,
      ...options,
    });
  }

  /**
   * Read object
   *
   * @param {Number} id
   * @param {string} path
   * @param {Object} options - The additional request options
   * @description Read the contents of an object at external storage
   * @returns {Promise}
   */
  readObject(id, path, options = {}) {
    const params = {
      path,
    };

    return this.apiClient.request({
      url: `/cnt/filesystems/integrations/${id}`,
      method: 'get',
      params,
      ...options,
    });
  }
}

export const operations = new Operations();

export default Operations;
